/**
 * Mock data for entity list — 15 records matching the exact shape
 * returned by fetchEntityListAction (response.data array).
 *
 * Shape per record:
 * {
 *   entity: { ...all entity fields },
 *   documents: [ { key, documentName, files: [{ isUploaded, fileName, filePath }] } ]
 * }
 */

export const MOCK_ENTITY_LIST = [
  {
    entity: {
      id: 1,
      entityId: "ENT-001",
      parentCode: "ACROSS",
      parentName: "Across Assist",
      entityName: "Sharma Travels Pvt Ltd",
      tradeName: "Sharma Travels",
      entityCategory: "client",
      entityLOBType: "travel",
      lobType: "travel",
      aaDepartmentFunction: "operations",
      contactPersonName: "Rajesh Sharma",
      contactPersonEmail: "rajesh@sharmatravels.com",
      contactPersonMobile: "9876543210",
      emailAddress: "rajesh@sharmatravels.com",
      spocEmailAddress: "spoc@sharmatravels.com",
      entityType: "private_limited",
      CompanypanNumber: "AABCS1234D",
      isGSTRegistered: "yes",
      gstNumberPrimary: "22AABCS1234D1Z5",
      isMSMERegistered: "no",
      hasBankDetails: "yes",
      bankName: "HDFC Bank",
      accountNumber: "50100123456789",
      ifscCode: "HDFC0001234",
      accountType: "current",
      branchName: "Connaught Place",
      isApproved: true,
      pinCode: "110001",
      city: "New Delhi",
      State: "Delhi",
    },
    documents: [
      {
        key: "doc_coi",
        documentName: "Certificate of Incorporation",
        files: [{ isUploaded: true, fileName: "coi.pdf", filePath: "#" }],
      },
      {
        key: "doc_pan",
        documentName: "PAN Card",
        files: [{ isUploaded: true, fileName: "pan.pdf", filePath: "#" }],
      },
      {
        key: "doc_gst_certificate",
        documentName: "GST Certificate",
        files: [{ isUploaded: false, fileName: "", filePath: "" }],
      },
    ],
  },
  {
    entity: {
      id: 2,
      entityId: "ENT-002",
      parentCode: "ACROSS",
      parentName: "Across Assist",
      entityName: "Mehta Insurance Brokers",
      tradeName: "Mehta Brokers",
      entityCategory: "Service Partner",
      entityLOBType: "company",
      lobType: "company",
      aaDepartmentFunction: "finance",
      contactPersonName: "Priya Mehta",
      contactPersonEmail: "priya@mehtabrokers.com",
      contactPersonMobile: "9123456780",
      emailAddress: "priya@mehtabrokers.com",
      spocEmailAddress: "spoc@mehtabrokers.com",
      entityType: "partnership",
      CompanypanNumber: "BBBPM5678E",
      isGSTRegistered: "no",
      isMSMERegistered: "yes",
      msmeNumber: "MH-12-0012345",
      hasBankDetails: "yes",
      bankName: "ICICI Bank",
      accountNumber: "123456789012",
      ifscCode: "ICIC0001234",
      accountType: "savings",
      branchName: "Bandra West",
      isApproved: false,
      pinCode: "400050",
      city: "Mumbai",
      State: "Maharashtra",
    },
    documents: [
      {
        key: "doc_partnershipDeed",
        documentName: "Partnership Deed",
        files: [{ isUploaded: true, fileName: "deed.pdf", filePath: "#" }],
      },
      {
        key: "doc_msme_certificate",
        documentName: "MSME Certificate",
        files: [{ isUploaded: false, fileName: "", filePath: "" }],
      },
    ],
  },
  {
    entity: {
      id: 3,
      entityId: "ENT-003",
      parentCode: "ACROSS",
      parentName: "Across Assist",
      entityName: "Gupta Auto Services",
      tradeName: "Gupta Auto",
      entityCategory: "Service Partner",
      entityLOBType: "auto",
      lobType: "auto",
      aaDepartmentFunction: "operations",
      contactPersonName: "Amit Gupta",
      contactPersonEmail: "amit@guptaauto.com",
      contactPersonMobile: "9988776655",
      emailAddress: "amit@guptaauto.com",
      spocEmailAddress: "spoc@guptaauto.com",
      entityType: "proprietorship",
      CompanypanNumber: "CCCPG9012F",
      isGSTRegistered: "yes",
      gstNumberPrimary: "07CCCPG9012F1Z3",
      isMSMERegistered: "no",
      hasBankDetails: "yes",
      bankName: "SBI",
      accountNumber: "30987654321",
      ifscCode: "SBIN0001234",
      accountType: "current",
      branchName: "Karol Bagh",
      isApproved: false,
      pinCode: "110005",
      city: "New Delhi",
      State: "Delhi",
    },
    documents: [
      {
        key: "doc_aadhar",
        documentName: "Aadhar Card",
        files: [{ isUploaded: true, fileName: "aadhar.pdf", filePath: "#" }],
      },
      {
        key: "doc_pan",
        documentName: "PAN Card",
        files: [{ isUploaded: true, fileName: "pan.pdf", filePath: "#" }],
      },
      {
        key: "doc_gst_certificate",
        documentName: "GST Certificate",
        files: [{ isUploaded: true, fileName: "gst.pdf", filePath: "#" }],
      },
    ],
  },
  {
    entity: {
      id: 4,
      entityId: "ENT-004",
      parentCode: "ACROSS",
      parentName: "Across Assist",
      entityName: "Verma Gadget World",
      tradeName: "Verma Gadgets",
      entityCategory: "client",
      entityLOBType: "gadget",
      lobType: "gadget",
      aaDepartmentFunction: "sales",
      contactPersonName: "Sunita Verma",
      contactPersonEmail: "sunita@vermagadgets.com",
      contactPersonMobile: "9871234560",
      emailAddress: "sunita@vermagadgets.com",
      spocEmailAddress: "spoc@vermagadgets.com",
      entityType: "llp",
      CompanypanNumber: "DDDVG3456G",
      isGSTRegistered: "yes",
      gstNumberPrimary: "29DDDVG3456G1Z1",
      isMSMERegistered: "yes",
      msmeNumber: "KA-05-0056789",
      hasBankDetails: "yes",
      bankName: "Axis Bank",
      accountNumber: "9876543210123",
      ifscCode: "UTIB0001234",
      accountType: "current",
      branchName: "MG Road",
      isApproved: true,
      pinCode: "560001",
      city: "Bengaluru",
      State: "Karnataka",
    },
    documents: [
      {
        key: "doc_partnershipDeed",
        documentName: "Partnership Deed",
        files: [{ isUploaded: true, fileName: "deed.pdf", filePath: "#" }],
      },
      {
        key: "doc_gst_certificate",
        documentName: "GST Certificate",
        files: [{ isUploaded: true, fileName: "gst.pdf", filePath: "#" }],
      },
      {
        key: "doc_msme_certificate",
        documentName: "MSME Certificate",
        files: [{ isUploaded: true, fileName: "msme.pdf", filePath: "#" }],
      },
    ],
  },
  {
    entity: {
      id: 5,
      entityId: "ENT-005",
      parentCode: "ACROSS",
      parentName: "Across Assist",
      entityName: "Singh Logistics Ltd",
      tradeName: "Singh Logistics",
      entityCategory: "Service Partner",
      entityLOBType: "company",
      lobType: "company",
      aaDepartmentFunction: "hr",
      contactPersonName: "Harpreet Singh",
      contactPersonEmail: "harpreet@singhlogistics.com",
      contactPersonMobile: "9765432109",
      emailAddress: "harpreet@singhlogistics.com",
      spocEmailAddress: "spoc@singhlogistics.com",
      entityType: "public_limited",
      CompanypanNumber: "EEESL7890H",
      isGSTRegistered: "yes",
      gstNumberPrimary: "03EEESL7890H1Z9",
      isMSMERegistered: "no",
      hasBankDetails: "yes",
      bankName: "Punjab National Bank",
      accountNumber: "4567890123456",
      ifscCode: "PUNB0001234",
      accountType: "current",
      branchName: "Sector 17",
      isApproved: true,
      pinCode: "160017",
      city: "Chandigarh",
      State: "Punjab",
    },
    documents: [
      {
        key: "doc_coi",
        documentName: "Certificate of Incorporation",
        files: [{ isUploaded: true, fileName: "coi.pdf", filePath: "#" }],
      },
      {
        key: "doc_pan",
        documentName: "PAN Card",
        files: [{ isUploaded: false, fileName: "", filePath: "" }],
      },
    ],
  },
  {
    entity: {
      id: 6,
      entityId: "ENT-006",
      parentCode: "ACROSS",
      parentName: "Across Assist",
      entityName: "Patel Healthcare Trust",
      tradeName: "Patel Health",
      entityCategory: "client",
      entityLOBType: "company",
      lobType: "company",
      aaDepartmentFunction: "it",
      contactPersonName: "Nilesh Patel",
      contactPersonEmail: "nilesh@patelhealth.com",
      contactPersonMobile: "9654321098",
      emailAddress: "nilesh@patelhealth.com",
      spocEmailAddress: "spoc@patelhealth.com",
      entityType: "trust",
      CompanypanNumber: "FFFPT2345I",
      isGSTRegistered: "no",
      isMSMERegistered: "no",
      hasBankDetails: "yes",
      bankName: "Bank of Baroda",
      accountNumber: "12345678901234",
      ifscCode: "BARB0001234",
      accountType: "savings",
      branchName: "Navrangpura",
      isApproved: false,
      pinCode: "380009",
      city: "Ahmedabad",
      State: "Gujarat",
    },
    documents: [
      {
        key: "doc_trustDeed",
        documentName: "Trust Deed",
        files: [{ isUploaded: false, fileName: "", filePath: "" }],
      },
      {
        key: "doc_utility_bill",
        documentName: "Utility Bill",
        files: [{ isUploaded: false, fileName: "", filePath: "" }],
      },
    ],
  },
  {
    entity: {
      id: 7,
      entityId: "ENT-007",
      parentCode: "ACROSS",
      parentName: "Across Assist",
      entityName: "Reddy Tech Solutions",
      tradeName: "Reddy Tech",
      entityCategory: "Service Partner",
      entityLOBType: "gadget",
      lobType: "gadget",
      aaDepartmentFunction: "it",
      contactPersonName: "Venkat Reddy",
      contactPersonEmail: "venkat@reddytech.com",
      contactPersonMobile: "9543210987",
      emailAddress: "venkat@reddytech.com",
      spocEmailAddress: "spoc@reddytech.com",
      entityType: "private_limited",
      CompanypanNumber: "GGGRT6789J",
      isGSTRegistered: "yes",
      gstNumberPrimary: "36GGGRT6789J1Z7",
      isMSMERegistered: "yes",
      msmeNumber: "TS-10-0078901",
      hasBankDetails: "yes",
      bankName: "Kotak Mahindra Bank",
      accountNumber: "9012345678901",
      ifscCode: "KKBK0001234",
      accountType: "current",
      branchName: "Banjara Hills",
      isApproved: true,
      pinCode: "500034",
      city: "Hyderabad",
      State: "Telangana",
    },
    documents: [
      {
        key: "doc_coi",
        documentName: "Certificate of Incorporation",
        files: [{ isUploaded: true, fileName: "coi.pdf", filePath: "#" }],
      },
      {
        key: "doc_gst_certificate",
        documentName: "GST Certificate",
        files: [{ isUploaded: true, fileName: "gst.pdf", filePath: "#" }],
      },
      {
        key: "doc_msme_certificate",
        documentName: "MSME Certificate",
        files: [{ isUploaded: true, fileName: "msme.pdf", filePath: "#" }],
      },
    ],
  },
  {
    entity: {
      id: 8,
      entityId: "ENT-008",
      parentCode: "ACROSS",
      parentName: "Across Assist",
      entityName: "Joshi & Associates",
      tradeName: "Joshi Associates",
      entityCategory: "client",
      entityLOBType: "travel",
      lobType: "travel",
      aaDepartmentFunction: "finance",
      contactPersonName: "Deepak Joshi",
      contactPersonEmail: "deepak@joshiassoc.com",
      contactPersonMobile: "9432109876",
      emailAddress: "deepak@joshiassoc.com",
      spocEmailAddress: "spoc@joshiassoc.com",
      entityType: "partnership",
      CompanypanNumber: "HHHJA0123K",
      isGSTRegistered: "yes",
      gstNumberPrimary: "08HHHJA0123K1Z5",
      isMSMERegistered: "no",
      hasBankDetails: "no",
      isApproved: false,
      pinCode: "302001",
      city: "Jaipur",
      State: "Rajasthan",
    },
    documents: [
      {
        key: "doc_partnershipDeed",
        documentName: "Partnership Deed",
        files: [{ isUploaded: true, fileName: "deed.pdf", filePath: "#" }],
      },
      {
        key: "doc_gst_certificate",
        documentName: "GST Certificate",
        files: [{ isUploaded: false, fileName: "", filePath: "" }],
      },
    ],
  },
  {
    entity: {
      id: 9,
      entityId: "ENT-009",
      parentCode: "ACROSS",
      parentName: "Across Assist",
      entityName: "Nair Marine Services",
      tradeName: "Nair Marine",
      entityCategory: "Service Partner",
      entityLOBType: "company",
      lobType: "company",
      aaDepartmentFunction: "operations",
      contactPersonName: "Suresh Nair",
      contactPersonEmail: "suresh@nairmarine.com",
      contactPersonMobile: "9321098765",
      emailAddress: "suresh@nairmarine.com",
      spocEmailAddress: "spoc@nairmarine.com",
      entityType: "proprietorship",
      CompanypanNumber: "IIINM4567L",
      isGSTRegistered: "no",
      isMSMERegistered: "yes",
      msmeNumber: "KL-01-0034567",
      hasBankDetails: "yes",
      bankName: "Federal Bank",
      accountNumber: "12345678901",
      ifscCode: "FDRL0001234",
      accountType: "savings",
      branchName: "Fort Kochi",
      isApproved: false,
      pinCode: "682001",
      city: "Kochi",
      State: "Kerala",
    },
    documents: [
      {
        key: "doc_aadhar",
        documentName: "Aadhar Card",
        files: [{ isUploaded: true, fileName: "aadhar.pdf", filePath: "#" }],
      },
      {
        key: "doc_utility_bill",
        documentName: "Utility Bill",
        files: [{ isUploaded: true, fileName: "bill.pdf", filePath: "#" }],
      },
      {
        key: "doc_msme_certificate",
        documentName: "MSME Certificate",
        files: [{ isUploaded: false, fileName: "", filePath: "" }],
      },
    ],
  },
  {
    entity: {
      id: 10,
      entityId: "ENT-010",
      parentCode: "ACROSS",
      parentName: "Across Assist",
      entityName: "Kapoor Events Society",
      tradeName: "Kapoor Events",
      entityCategory: "client",
      entityLOBType: "company",
      lobType: "company",
      aaDepartmentFunction: "marketing",
      contactPersonName: "Ritu Kapoor",
      contactPersonEmail: "ritu@kapoorevents.com",
      contactPersonMobile: "9210987654",
      emailAddress: "ritu@kapoorevents.com",
      spocEmailAddress: "spoc@kapoorevents.com",
      entityType: "society",
      CompanypanNumber: "JJJKE8901M",
      isGSTRegistered: "no",
      isMSMERegistered: "no",
      hasBankDetails: "yes",
      bankName: "Canara Bank",
      accountNumber: "0987654321098",
      ifscCode: "CNRB0001234",
      accountType: "savings",
      branchName: "Lajpat Nagar",
      isApproved: true,
      pinCode: "110024",
      city: "New Delhi",
      State: "Delhi",
    },
    documents: [
      {
        key: "doc_pan",
        documentName: "PAN Card",
        files: [{ isUploaded: true, fileName: "pan.pdf", filePath: "#" }],
      },
      {
        key: "doc_utility_bill",
        documentName: "Utility Bill",
        files: [{ isUploaded: true, fileName: "bill.pdf", filePath: "#" }],
      },
    ],
  },
  {
    entity: {
      id: 11,
      entityId: "ENT-011",
      parentCode: "ACROSS",
      parentName: "Across Assist",
      entityName: "Bansal Freight Carriers",
      tradeName: "Bansal Freight",
      entityCategory: "Service Partner",
      entityLOBType: "auto",
      lobType: "auto",
      aaDepartmentFunction: "operations",
      contactPersonName: "Mohit Bansal",
      contactPersonEmail: "mohit@bansalfreight.com",
      contactPersonMobile: "9109876543",
      emailAddress: "mohit@bansalfreight.com",
      spocEmailAddress: "spoc@bansalfreight.com",
      entityType: "proprietorship",
      CompanypanNumber: "KKKBF2345N",
      isGSTRegistered: "yes",
      gstNumberPrimary: "09KKKBF2345N1Z3",
      isMSMERegistered: "no",
      hasBankDetails: "yes",
      bankName: "Union Bank",
      accountNumber: "3456789012345",
      ifscCode: "UBIN0001234",
      accountType: "current",
      branchName: "Nehru Place",
      isApproved: false,
      pinCode: "110019",
      city: "New Delhi",
      State: "Delhi",
    },
    documents: [
      {
        key: "doc_aadhar",
        documentName: "Aadhar Card",
        files: [{ isUploaded: false, fileName: "", filePath: "" }],
      },
      {
        key: "doc_gst_certificate",
        documentName: "GST Certificate",
        files: [{ isUploaded: false, fileName: "", filePath: "" }],
      },
    ],
  },
  {
    entity: {
      id: 12,
      entityId: "ENT-012",
      parentCode: "ACROSS",
      parentName: "Across Assist",
      entityName: "Iyer Consulting LLP",
      tradeName: "Iyer Consulting",
      entityCategory: "client",
      entityLOBType: "company",
      lobType: "company",
      aaDepartmentFunction: "finance",
      contactPersonName: "Krishnan Iyer",
      contactPersonEmail: "krishnan@iyerconsulting.com",
      contactPersonMobile: "9098765432",
      emailAddress: "krishnan@iyerconsulting.com",
      spocEmailAddress: "spoc@iyerconsulting.com",
      entityType: "llp",
      CompanypanNumber: "LLLCI6789O",
      isGSTRegistered: "yes",
      gstNumberPrimary: "33LLLCI6789O1Z1",
      isMSMERegistered: "yes",
      msmeNumber: "TN-07-0089012",
      hasBankDetails: "yes",
      bankName: "Indian Bank",
      accountNumber: "6789012345678",
      ifscCode: "IDIB0001234",
      accountType: "current",
      branchName: "Anna Nagar",
      isApproved: true,
      pinCode: "600040",
      city: "Chennai",
      State: "Tamil Nadu",
    },
    documents: [
      {
        key: "doc_partnershipDeed",
        documentName: "Partnership Deed",
        files: [{ isUploaded: true, fileName: "deed.pdf", filePath: "#" }],
      },
      {
        key: "doc_gst_certificate",
        documentName: "GST Certificate",
        files: [{ isUploaded: true, fileName: "gst.pdf", filePath: "#" }],
      },
      {
        key: "doc_msme_certificate",
        documentName: "MSME Certificate",
        files: [{ isUploaded: true, fileName: "msme.pdf", filePath: "#" }],
      },
    ],
  },
  {
    entity: {
      id: 13,
      entityId: "ENT-013",
      parentCode: "ACROSS",
      parentName: "Across Assist",
      entityName: "Mishra Pharma Distributors",
      tradeName: "Mishra Pharma",
      entityCategory: "Service Partner",
      entityLOBType: "company",
      lobType: "company",
      aaDepartmentFunction: "sales",
      contactPersonName: "Alok Mishra",
      contactPersonEmail: "alok@mishrapharma.com",
      contactPersonMobile: "9087654321",
      emailAddress: "alok@mishrapharma.com",
      spocEmailAddress: "spoc@mishrapharma.com",
      entityType: "private_limited",
      CompanypanNumber: "MMMMP0123P",
      isGSTRegistered: "yes",
      gstNumberPrimary: "09MMMMP0123P1Z9",
      isMSMERegistered: "no",
      hasBankDetails: "yes",
      bankName: "Yes Bank",
      accountNumber: "9012345678901",
      ifscCode: "YESB0001234",
      accountType: "current",
      branchName: "Hazratganj",
      isApproved: false,
      pinCode: "226001",
      city: "Lucknow",
      State: "Uttar Pradesh",
    },
    documents: [
      {
        key: "doc_coi",
        documentName: "Certificate of Incorporation",
        files: [{ isUploaded: true, fileName: "coi.pdf", filePath: "#" }],
      },
      {
        key: "doc_directorPan",
        documentName: "Director PAN",
        files: [{ isUploaded: false, fileName: "", filePath: "" }],
      },
      {
        key: "doc_gst_certificate",
        documentName: "GST Certificate",
        files: [{ isUploaded: true, fileName: "gst.pdf", filePath: "#" }],
      },
    ],
  },
  {
    entity: {
      id: 14,
      entityId: "ENT-014",
      parentCode: "ACROSS",
      parentName: "Across Assist",
      entityName: "Chatterjee Exports",
      tradeName: "Chatterjee Exports",
      entityCategory: "client",
      entityLOBType: "travel",
      lobType: "travel",
      aaDepartmentFunction: "operations",
      contactPersonName: "Subhash Chatterjee",
      contactPersonEmail: "subhash@chatterjeeexports.com",
      contactPersonMobile: "9076543210",
      emailAddress: "subhash@chatterjeeexports.com",
      spocEmailAddress: "spoc@chatterjeeexports.com",
      entityType: "partnership",
      CompanypanNumber: "NNNCE4567Q",
      isGSTRegistered: "yes",
      gstNumberPrimary: "19NNNCE4567Q1Z7",
      isMSMERegistered: "yes",
      msmeNumber: "WB-06-0012345",
      hasBankDetails: "yes",
      bankName: "UCO Bank",
      accountNumber: "1234567890123",
      ifscCode: "UCBA0001234",
      accountType: "current",
      branchName: "Park Street",
      isApproved: true,
      pinCode: "700016",
      city: "Kolkata",
      State: "West Bengal",
    },
    documents: [
      {
        key: "doc_partnershipDeed",
        documentName: "Partnership Deed",
        files: [{ isUploaded: true, fileName: "deed.pdf", filePath: "#" }],
      },
      {
        key: "doc_gst_certificate",
        documentName: "GST Certificate",
        files: [{ isUploaded: true, fileName: "gst.pdf", filePath: "#" }],
      },
      {
        key: "doc_msme_certificate",
        documentName: "MSME Certificate",
        files: [{ isUploaded: true, fileName: "msme.pdf", filePath: "#" }],
      },
    ],
  },
  {
    entity: {
      id: 15,
      entityId: "ENT-015",
      parentCode: "ACROSS",
      parentName: "Across Assist",
      entityName: "Desai Renewable Energy",
      tradeName: "Desai Energy",
      entityCategory: "Service Partner",
      entityLOBType: "company",
      lobType: "company",
      aaDepartmentFunction: "it",
      contactPersonName: "Hiral Desai",
      contactPersonEmail: "hiral@desaienergy.com",
      contactPersonMobile: "9065432109",
      emailAddress: "hiral@desaienergy.com",
      spocEmailAddress: "spoc@desaienergy.com",
      entityType: "public_limited",
      CompanypanNumber: "OOODE8901R",
      isGSTRegistered: "yes",
      gstNumberPrimary: "24OOODE8901R1Z5",
      isMSMERegistered: "no",
      hasBankDetails: "yes",
      bankName: "HDFC Bank",
      accountNumber: "5678901234567",
      ifscCode: "HDFC0005678",
      accountType: "current",
      branchName: "Satellite",
      isApproved: false,
      pinCode: "380015",
      city: "Ahmedabad",
      State: "Gujarat",
    },
    documents: [
      {
        key: "doc_coi",
        documentName: "Certificate of Incorporation",
        files: [{ isUploaded: true, fileName: "coi.pdf", filePath: "#" }],
      },
      {
        key: "doc_directorPan",
        documentName: "Director PAN",
        files: [{ isUploaded: true, fileName: "dirpan.pdf", filePath: "#" }],
      },
      {
        key: "doc_gst_certificate",
        documentName: "GST Certificate",
        files: [{ isUploaded: false, fileName: "", filePath: "" }],
      },
    ],
  },
];

/**
 * Simulates the fetchEntityListAction response shape with client-side
 * filtering and pagination over MOCK_ENTITY_LIST.
 */
export const fetchMockEntityList = (
  pageNumber = 1,
  pageSize = 10,
  filters = {},
) => {
  const { entityName, emailAddress, entityCategory, status } = filters;

  let filtered = [...MOCK_ENTITY_LIST];

  if (entityName) {
    filtered = filtered.filter((r) =>
      r.entity.entityName?.toLowerCase().includes(entityName.toLowerCase()),
    );
  }
  if (emailAddress) {
    filtered = filtered.filter((r) =>
      r.entity.emailAddress?.toLowerCase().includes(emailAddress.toLowerCase()),
    );
  }
  if (entityCategory) {
    filtered = filtered.filter(
      (r) =>
        r.entity.entityCategory?.toLowerCase() === entityCategory.toLowerCase(),
    );
  }
  if (status) {
    filtered = filtered.filter((r) => {
      const isApproved = r.entity.isApproved;
      if (status === "Done") return isApproved === true;
      if (status === "pending") return isApproved === false;
      return true;
    });
  }

  const totalItems = filtered.length;
  const totalPages = Math.ceil(totalItems / pageSize);
  const start = (pageNumber - 1) * pageSize;
  const pageData = filtered.slice(start, start + pageSize);

  return {
    success: true,
    data: pageData,
    pagination: {
      currentPage: pageNumber,
      totalPages,
      totalItems,
      pageSize,
      hasNextPage: pageNumber < totalPages,
      hasPreviousPage: pageNumber > 1,
    },
    message: "Mock entity list fetched successfully",
  };
};
